import * as t from "io-ts";
import { withFallback } from "io-ts-types";
import { placeT } from "./place";
export const createSavedLocationT = t.strict({
    customName: t.string,
    type: t.union([t.literal("TERMINAL"), t.literal("FAVORITE")]),
    visibleToDrivers: withFallback(t.boolean, false),
    place: placeT,
    openingTime: t.string,
    contactName: t.string,
    contactPhoneNumber: t.string,
});
export const savedLocationT = t.intersection([
    createSavedLocationT,
    t.strict({ id: t.string }),
]);
export const savedLocationsT = t.array(savedLocationT);
//# sourceMappingURL=saved-locations.js.map